import React, { useState, useEffect } from "react";
import "./datatable.scss";
import { Link } from "react-router-dom";
import tableup from "../../../../assets/tableup.svg";
import tabledown from "../../../../assets/tabledown.svg";
import { Accordion, Modal } from "react-bootstrap";
import axios from "axios";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ReactPaginate from "react-paginate";
import { Api_Url } from "../../../../utils/ApiUrl";
import { toast } from "react-toastify";
const DataTable = ({
  project,
  setRoutes,
  setShow,
  agents,
  leadersLoader,
  setAgents,
  pages,
  handlePageChange,
  page,
  pageCount,
  currentPage,
  GetAllRounds,
  setUserDel,
  sub,
  setOrderDirection,
  setOrderField,
  setBlockUnblock,
  blockUnblock,
  tomiPrice,
  usdPrice,
  btcPrice,
  pepePrice,
  linkPrice,
  uniPrice,
  dopPrice,
  gemsPrice,

  pagination,
  tok,

  searchBy,
  searchQuery,
  startDate,
  endDate,
  privateSaleFilter,
  selectedLeaders,
  selectedRoles,

  activeFilter,
  premiumFilter,
  orderDirection,
  orderField,
}) => {
  // const [usdPrice, setUsdPrice] = useState(0);
  const [rend, setRend] = useState(false);

  // useEffect(() => {
  //   axios
  //     .get("https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD")
  //     .then((res) => {
  //       setUsdPrice(res?.data?.USD);
  //       // setEthUsd(res.data);
  //     });
  // }, []);
  const [claimsCSVData, setClaimsCSVData] = useState([]);
  const [claimsCSVDataHeaders, setClaimsCSVDataHeaders] = useState([]);
  const [data, setexceldata] = useState([]);

  const [showbtn, setShowBtn] = useState(true);
  const [loading, setLoading] = useState("");
  const [modalDetail, setModalDetail] = useState({});

  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);

  const handleClose1 = () => {
    setShow1(false);
  };

  const handleClose2 = () => {
    setShow2(false);
  };

  const [copy, setCopy] = useState(false);
  const textCopiedFun = (index) => {
    setCopy(index);

    setTimeout(() => {
      setCopy(false);
    }, 1000);
  };
  function convertToTitleCase(input) {
    if (input) {
      let words = input
        .split("_")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        );

      if (words[0] === "mini" || words[0] === "Mini") {
        return "Ambassador";
      }
      if (
        words[words.length - 1].toLowerCase() === "agent" &&
        (words[0] != "mini" || words[0] != "Mini")
      ) {
        words[words.length - 1] = "Leader";
      }
      if (words[0] === "super" || words[0] === "Super") {
        return "Super";
      } else if (words[0] !== "agent") {
        return words.join(" ");
      } else {
        return "Leader";
      }
    } else {
      return "";
    }
  }

  function convertDateFormat(input) {
    const date = new Date(input);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    return `${day}/${month}/${year}\n${hours}:${minutes} UTC`;
  }

  const toastErrorFunc = () => {
    toast.error("No data found to export");
  };
  const getAllClaimsData = async () => {
    // console.log("export csv: ", project);

    setLoading(true);
    setShowBtn(false);
    var config = {
      method: "post",
      // get api so don't need to add useAdminAllowed();
      url: `${Api_Url}/users/admin/leaders`,
      data: {
        limit: 5000,
        offset: 1,
        ...(activeFilter !== null && { isActive: activeFilter }),

        ...(selectedLeaders?.length > 0 && { nameFilter: selectedLeaders }),
        ...(selectedRoles?.length > 0 && { roleFilter: selectedRoles }),
        ...(premiumFilter !== null && { isPremium: premiumFilter }),
        ...(searchQuery &&
          searchBy == "walletAddress" && {
            walletAddressFilter: searchQuery,
          }),
        ...(searchQuery &&
          searchBy == "accessCode" && { accessCodeFilter: searchQuery }),

        // walletAddressFilter:,
        // accessCodeFilter:,
        ...(privateSaleFilter?.length > 0 && {
          privateSaleFilter: privateSaleFilter,
        }),

        ...(startDate && {
          startDate: startDate,
        }),

        ...(endDate && {
          endDate: endDate,
        }),

        orderField: orderField,
        orderDirection: orderDirection,
      },
      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    // let dynamicQuery = config.url;

    // if (leaderFilter) {
    //   dynamicQuery += `&name=${encodeURIComponent(leaderFilter)}`;
    // }

    // if (roleTypeFilter) {
    //   dynamicQuery += `&leaderType=${encodeURIComponent(roleTypeFilter)}`;
    // }

    // if (activeFilter) {
    //   dynamicQuery += `&active=${activeFilter}`;
    // }
    // if (inActiveFilter) {
    //   dynamicQuery += `&inActive=${inActiveFilter}`;
    // }
    // if (premiumFilter == "premium") {
    //   dynamicQuery += `&isPremium=true`;
    // } else if (premiumFilter == "basic") {
    //   dynamicQuery += `&isPremium=false`;
    // }

    // if (searchQuery) {
    //   dynamicQuery += `&search=${encodeURIComponent(searchQuery)}`;
    // }
    // if (orderField) {
    //   dynamicQuery += `&orderField=${orderField}&orderDirection=${orderDirection}`;
    // }
    // if (user?.role == "god_agent") {
    //   dynamicQuery += `&myTree=${myTree}`;
    // }
    // config.url = dynamicQuery;

    axios(config)
      .then(function (response) {
        const resData = response?.data?.data?.data?.leaders;

        const dataForCsv = resData?.map((item) => {
          let name = item?.name;
          let role =
            item?.role === "mini_agent"
              ? "Ambassador"
              : item?.role === "god_agent"
                ? "God Leader"
                : item?.role === "super_agent"
                  ? "Super Leader"
                  : item?.role === "agent"
                    ? "Leader"
                    : item?.role === "mega_agent"
                      ? "Mega Leader"
                      : "";
          let email = item?.email;

          let code = item?.accessCode;
          let commission = item?.commission;
          let Purchases = item?.directSales;
          let Earning = item?.totalAmountEarned;
          let myEarnings = item?.myEarnings;
          let totalSales = item?.directAmountInUsd;
          let DirectSales = item?.directAmountInUsd;
          let indirectSales = item?.indirectAmountInUsd;
          let amount = item?.totalDop;
          return {
            name: name,
            role: role,
            email: email,
            code: code,
            commission: commission,
            Purchases: Purchases,
            Earning: Earning,
            myEarnings: myEarnings,
            totalSales: totalSales,
            DirectSales: DirectSales,
            indirectSales: indirectSales,
            amount: amount,
          };
        });
        const headers = [
          { label: "name", key: "name" },
          { label: "role", key: "role" },
          { label: "leadersEmail", key: "email" },

          { label: "code", key: "code" },
          { label: "commission", key: "commission" },
          { label: "Purchases", key: "Purchases" },
          { label: "Earning", key: "Earning" },
          { label: "myEarnings", key: "myEarnings" },
          { label: "totalSales", key: "totalSales" },
          { label: "DirectSales", key: "DirectSales" },
          { label: "indirectSales", key: "indirectSales" },
          { label: "amount", key: "amount" },
        ];
        setClaimsCSVData(dataForCsv);
        setClaimsCSVDataHeaders(headers);

        setexceldata(dataForCsv);
        setLoading(false);
      })
      .catch(function (error) {
        if (error?.response?.status == 401) {
          // localStorage.removeItem("accessToken");
          // history.push("/");
        }
        setLoading(false);
      });
  };

  const tokenData = [
    { key: "totalEth", name: "ETH", img: "/assets/eth.svg", decimals: 5 },
    { key: "totalUsdt", name: "USDT", img: "/assets/usdt.svg", decimals: 2 },
    { key: "totalUsdc", name: "USDC", img: "/assets/usdc.svg", decimals: 2 },
    { key: "totalGems", name: "GEMS", img: "/assets/gems.svg", decimals: 1 },
    { key: "totalWbtc", name: "WBTC", img: "/assets/wbtc.svg", decimals: 6 },
    { key: "totalLink", name: "LINK", img: "/assets/link.svg", decimals: 2 },
    { key: "totalTomi", name: "TOMI", img: "/assets/tomi.svg", decimals: 2 },
    { key: "totalPepe", name: "PEPE", img: "/assets/pepe.svg", decimals: 2 },
    { key: "totalUni", name: "UNI", img: "/assets/uni.svg", decimals: 2 },
    { key: "totalDopToken", name: "DOP", img: "/assets/dop.svg", decimals: 2 },
  ];

  const tokenDataEarnings = [
    { key: "myEarningsEth", name: "ETH", img: "/assets/eth.svg", decimals: 5 },
    {
      key: "myEarningsUsdt",
      name: "USDT",
      img: "/assets/usdt.svg",
      decimals: 2,
    },
    {
      key: "myEarningsUsdc",
      name: "USDC",
      img: "/assets/usdc.svg",
      decimals: 2,
    },
    {
      key: "myEarningsGems",
      name: "GEMS",
      img: "/assets/gems.svg",
      decimals: 1,
    },
    {
      key: "myEarningsWbtc",
      name: "WBTC",
      img: "/assets/wbtc.svg",
      decimals: 6,
    },
    {
      key: "myEarningsLink",
      name: "LINK",
      img: "/assets/link.svg",
      decimals: 2,
    },
    {
      key: "myEarningsTomi",
      name: "TOMI",
      img: "/assets/tomi.svg",
      decimals: 2,
    },
    {
      key: "myEarningsPepe",
      name: "PEPE",
      img: "/assets/pepe.svg",
      decimals: 2,
    },
    { key: "myEarningsUni", name: "UNI", img: "/assets/uni.svg", decimals: 2 },
    {
      key: "myEarningsDopToken",
      name: "DOP",
      img: "/assets/dop.svg",
      decimals: 2,
    },
  ];

  function formatTokenValue(tokenValue, decimals) {
    const num = parseFloat(tokenValue);
    if (isNaN(num) || num === 0) return null; // Hide zero values

    if (num >= 1000000) {
      return (num / 1000000)?.toFixed(2) + "M";
    } else if (num >= 1000) {
      return (num / 1000)?.toFixed(2) + "K";
    } else {
      return num.toFixed(decimals); // Apply specific decimal formatting
    }
  }

  return (
    <>
      <section className="datatable">
        {/* {agents?.length != 0 && (
          <div className="mb-3">
            <div className="upperbtn">
              {showbtn && (
                <button onClick={getAllClaimsData} className="mygreybtn">
                  export
                </button>
              )}
              {loading ? (
                <button className="mygreybtn">
                  <div className="text-center">
                    <div class="d-flex align-items-center justify-content-center">
                      <div class="spinner-border text-info" role="status">
                        <span class="sr-only"></span>
                      </div>
                    </div>
                  </div>
                </button>
              ) : (
                <>
                  {claimsCSVData && claimsCSVData.length > 0 && (
                    <CSVLink
                      data={claimsCSVData}
                      headers={claimsCSVDataHeaders}
                      filename={"Leaders_data.csv"}
                      className="mygreybtn"
                    >
                      Export CSV
                    </CSVLink>
                  )}
                </>
              )}
            </div>
          </div>
        )} */}
        <div
          className="table-responsive foroverflowvisibleclasss"
          // style={{ minHeight: "60vh" }}
        >
          <table class="table">
            <thead>
              <tr>
                <th>
                  <div className="parent-tag">
                    Date Created{" "}
                    <div
                      className="filter-btn"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setOrderField("createdAt");
                        setOrderDirection((prev) =>
                          prev == -1 ? 1 : prev == 1 ? -1 : -1,
                        );
                      }}
                    >
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                          fill="#77868B"
                        />
                      </svg>
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                          fill="#77868B"
                        />
                      </svg>
                    </div>
                  </div>
                </th>
                <th>
                  <div className="parent-tag">
                    Name/Wallet{" "}
                    <div
                      className="filter-btn"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setOrderField("name");
                        setOrderDirection((prev) =>
                          prev == -1 ? 1 : prev == 1 ? -1 : -1,
                        );
                      }}
                    >
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                          fill="#77868B"
                        />
                      </svg>
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                          fill="#77868B"
                        />
                      </svg>
                    </div>
                  </div>
                </th>
                <th>
                  <div className="parent-tag">
                    Leader's Email{" "}
                    {/* <div className="filter-btn">
                      <img src={tableup} alt="img" className="img-fluid" />
                      <img src={tabledown} alt="img" className="img-fluid" />
                    </div> */}
                  </div>
                </th>
                <th>
                  <div className="parent-tag">
                    Role{" "}
                    {/* <div className="filter-btn">
                      <img src={tableup} alt="img" className="img-fluid" />
                      <img src={tabledown} alt="img" className="img-fluid" />
                    </div> */}
                  </div>
                </th>

                <th>
                  <div className="parent-tag">
                    Plan
                    <div
                      className="filter-btn"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setOrderField("UserPremiumPlan");
                        setOrderDirection((prev) =>
                          prev == -1 ? 1 : prev == 1 ? -1 : -1,
                        );
                      }}
                    >
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                          fill="#77868B"
                        />
                      </svg>
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                          fill="#77868B"
                        />
                      </svg>
                    </div>
                  </div>
                </th>
                <th>
                  <div className="parent-tag">Miners Sold</div>
                </th>
                <th>
                  <div className="parent-tag">Total Sold</div>
                </th>
                <th>
                  <div className="parent-tag">
                    Leader Earning{" "}
                    <div
                      className="filter-btn"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setOrderField("totalAmountEarned");
                        setOrderDirection((prev) =>
                          prev == -1 ? 1 : prev == 1 ? -1 : -1,
                        );
                      }}
                    >
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                          fill="#77868B"
                        />
                      </svg>
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                          fill="#77868B"
                        />
                      </svg>
                    </div>
                  </div>
                </th>
                <th>
                  <div className="parent-tag">Details </div>
                </th>
                {/* {sub != true ? <th>Action</th> : null} */}
              </tr>
            </thead>
            <tbody>
              {agents?.length > 0 ? (
                agents?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <div className="twice-text">
                          <h6>
                            {convertDateFormat(item?.createdAt)?.slice(0, 10)}
                          </h6>
                          <p>
                            {convertDateFormat(item?.createdAt)?.slice(12, 20)}
                          </p>
                        </div>
                      </td>
                      <td>
                        {item?.name}
                        <div className="walletaddresspara">
                          <p>
                            {copy ? (
                              <span className="adadasdasdasdasdasdsad">
                                {item?.walletAddress?.slice(0, 8)}...
                                {item?.walletAddress?.slice(
                                  item?.walletAddress?.length - 5,
                                  item?.walletAddress?.length,
                                )}{" "}
                                <svg
                                  style={{ cursor: "pointer" }}
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  className={copy === index && "copy-button "}
                                >
                                  <path
                                    d="M13 10.5V13.5C13 16 12 17 9.5 17H6.5C4 17 3 16 3 13.5V10.5C3 8 4 7 6.5 7H9.5C12 7 13 8 13 10.5Z"
                                    stroke="#77868B"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M17 6.5V9.5C17 12 16 13 13.5 13H12.7143V10.7857C12.7143 8.28571 11.7143 7.28571 9.21429 7.28571H7V6.5C7 4 8 3 10.5 3H13.5C16 3 17 4 17 6.5Z"
                                    stroke="#77868B"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                {copy === index && (
                                  <p className="copy-text">Copied</p>
                                )}
                              </span>
                            ) : (
                              <>
                                {item?.walletAddress && (
                                  <>
                                    <CopyToClipboard
                                      text={item?.walletAddress}
                                      onCopy={(e) => textCopiedFun(index)}
                                    >
                                      <span className="adadasdasdasdasdasdsad">
                                        {item?.walletAddress?.slice(0, 8)}...
                                        {item?.walletAddress?.slice(
                                          item?.walletAddress?.length - 5,
                                          item?.walletAddress?.length,
                                        )}{" "}
                                        <svg
                                          style={{ cursor: "pointer" }}
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          className={
                                            copy === index && "copy-button "
                                          }
                                        >
                                          <path
                                            d="M13 10.5V13.5C13 16 12 17 9.5 17H6.5C4 17 3 16 3 13.5V10.5C3 8 4 7 6.5 7H9.5C12 7 13 8 13 10.5Z"
                                            stroke="#77868B"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                          <path
                                            d="M17 6.5V9.5C17 12 16 13 13.5 13H12.7143V10.7857C12.7143 8.28571 11.7143 7.28571 9.21429 7.28571H7V6.5C7 4 8 3 10.5 3H13.5C16 3 17 4 17 6.5Z"
                                            stroke="#77868B"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                        </svg>
                                      </span>
                                    </CopyToClipboard>
                                    {copy === index && (
                                      <p className="copy-text">Copied</p>
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </p>
                        </div>
                      </td>
                      <td>{item?.email}</td>
                      <td>{convertToTitleCase(item?.role)}</td>

                      <td>{item?.UserPremiumPlan ? "Premium" : "Basic"} </td>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          {parseFloat(
                            item?.totalMiniMiners +
                              item?.totalMegaMiners +
                              item?.totalStandardMiners,
                          )?.toLocaleString()}
                          <div class="dropdown dropdownnodesminers">
                            <button
                              class="dropdown-toggle"
                              type="button"
                              id="dropdownMenuButton1"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="19"
                                viewBox="0 0 18 19"
                                fill="none"
                              >
                                <path
                                  d="M9 17.249C13.1421 17.249 16.5 13.8912 16.5 9.74902C16.5 5.60689 13.1421 2.24902 9 2.24902C4.85786 2.24902 1.5 5.60689 1.5 9.74902C1.5 13.8912 4.85786 17.249 9 17.249Z"
                                  stroke="#77868B"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M9 12.749V9.74902"
                                  stroke="#77868B"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M9 6.74902H9.00833"
                                  stroke="#77868B"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </button>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <div className="twice">
                                <p>Mini</p>
                                <h6>{item?.totalMiniMiners}</h6>
                              </div>
                              <div className="twice">
                                <p>Standard</p>
                                <h6>{item?.totalStandardMiners}</h6>
                              </div>
                              <div className="twice">
                                <p>Mega</p>
                                <h6>{item?.totalMegaMiners}</h6>
                              </div>
                            </ul>
                          </div>
                        </div>
                      </td>

                      <td>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          ${formatTokenValue(item?.totalAmountInUsd, 2)}
                          <div class="dropdown dropdownnodesminers">
                            <button
                              class="dropdown-toggle"
                              type="button"
                              id="dropdownMenuButton1"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="19"
                                viewBox="0 0 18 19"
                                fill="none"
                              >
                                <path
                                  d="M9 17.249C13.1421 17.249 16.5 13.8912 16.5 9.74902C16.5 5.60689 13.1421 2.24902 9 2.24902C4.85786 2.24902 1.5 5.60689 1.5 9.74902C1.5 13.8912 4.85786 17.249 9 17.249Z"
                                  stroke="#77868B"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M9 12.749V9.74902"
                                  stroke="#77868B"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M9 6.74902H9.00833"
                                  stroke="#77868B"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </button>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <div className="py-2">
                                {item?.totalEth != 0 ? (
                                  <div className="twice">
                                    <p>ETH</p>
                                    <h6>
                                      {item?.totalEth
                                        ? parseFloat(item.totalEth)?.toFixed(5)
                                        : "0"}
                                    </h6>
                                  </div>
                                ) : null}
                                {item?.totalUsdt != 0 ? (
                                  <div className="twice">
                                    <p>USDT</p>
                                    <h6>
                                      {item?.totalUsdt
                                        ? parseFloat(item.totalUsdt)?.toFixed(2)
                                        : "0"}
                                    </h6>
                                  </div>
                                ) : null}
                                {item?.totalUsdc != 0 ? (
                                  <div className="twice">
                                    <p>USDC</p>
                                    <h6>
                                      {item?.totalUsdc
                                        ? parseFloat(item.totalUsdc)?.toFixed(2)
                                        : "0"}
                                    </h6>
                                  </div>
                                ) : null}
                                {/* {item?.totalWbtc != 0 ? (
                                  <div className="twice">
                                    <p>WBTC</p>
                                    <h6>
                                      {item?.totalWbtc
                                        ? parseFloat(item.totalWbtc)?.toFixed(6)
                                        : "0"}
                                    </h6>
                                  </div>
                                ) : null} */}
                                {item?.totalGems != 0 ? (
                                  <div className="twice">
                                    <p>GEMS</p>
                                    <h6>
                                      {item?.totalGems
                                        ? parseFloat(item.totalGems)?.toFixed(1)
                                        : "0"}
                                    </h6>
                                  </div>
                                ) : null}
                              </div>

                              <a
                                style={{
                                  color: "#329879",
                                  justifyContent: "center",
                                }}
                                onClick={() => {
                                  setModalDetail(item);
                                  setShow1(true);
                                }}
                              >
                                View All
                              </a>
                            </ul>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          ${formatTokenValue(item?.totalAmountEarned, 2)}
                          <div class="dropdown dropdownnodesminers">
                            <button
                              class="dropdown-toggle"
                              type="button"
                              id="dropdownMenuButton1"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="19"
                                viewBox="0 0 18 19"
                                fill="none"
                              >
                                <path
                                  d="M9 17.249C13.1421 17.249 16.5 13.8912 16.5 9.74902C16.5 5.60689 13.1421 2.24902 9 2.24902C4.85786 2.24902 1.5 5.60689 1.5 9.74902C1.5 13.8912 4.85786 17.249 9 17.249Z"
                                  stroke="#77868B"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M9 12.749V9.74902"
                                  stroke="#77868B"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M9 6.74902H9.00833"
                                  stroke="#77868B"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </button>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <div className="py-2">
                                {item?.myEarningsEth != 0 ? (
                                  <div className="twice">
                                    <p>ETH</p>
                                    <h6>
                                      {item?.myEarningsEth
                                        ? parseFloat(
                                            item.myEarningsEth,
                                          )?.toFixed(5)
                                        : "0"}
                                    </h6>
                                  </div>
                                ) : null}
                                {item?.myEarningsUsdt != 0 ? (
                                  <div className="twice">
                                    <p>USDT</p>
                                    <h6>
                                      {item?.myEarningsUsdt
                                        ? parseFloat(
                                            item.myEarningsUsdt,
                                          )?.toFixed(2)
                                        : "0"}
                                    </h6>
                                  </div>
                                ) : null}
                                {item?.myEarningsUsdc != 0 ? (
                                  <div className="twice">
                                    <p>USDC</p>
                                    <h6>
                                      {item?.myEarningsUsdc
                                        ? parseFloat(
                                            item.myEarningsUsdc,
                                          )?.toFixed(2)
                                        : "0"}
                                    </h6>
                                  </div>
                                ) : null}
                                {/* {item?.myEarningsWbtc != 0 ? (
                                  <div className="twice">
                                    <p>WBTC</p>
                                    <h6>
                                      {item?.myEarningsWbtc
                                        ? parseFloat(
                                            item.myEarningsWbtc
                                          )?.toFixed(6)
                                        : "0"}
                                    </h6>
                                  </div>
                                ) : null} */}
                                {item?.myEarningsGems != 0 ? (
                                  <div className="twice">
                                    <p>GEMS</p>
                                    <h6>
                                      {item?.myEarningsGems
                                        ? parseFloat(
                                            item.myEarningsGems,
                                          )?.toFixed(1)
                                        : "0"}
                                    </h6>
                                  </div>
                                ) : null}
                              </div>

                              <a
                                style={{
                                  color: "#329879",
                                  justifyContent: "center",
                                }}
                                onClick={() => {
                                  setModalDetail(item);
                                  setShow2(true);
                                }}
                              >
                                View All
                              </a>
                            </ul>
                          </div>
                        </div>
                      </td>
                      <td>
                        <a
                          onClick={() => {
                            setRoutes(true);
                            setUserDel(item);
                            setBlockUnblock(item?.isDeleted);
                          }}
                        >
                          {" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17"
                            height="16"
                            viewBox="0 0 17 16"
                            fill="none"
                          >
                            <path
                              d="M3.16683 8.66669L11.2802 8.66669L7.5535 12.3934L8.50016 13.3334L13.8335 8.00002L8.50016 2.66669L7.56016 3.60669L11.2802 7.33335L3.16683 7.33335L3.16683 8.66669Z"
                              fill="#02171D"
                            />
                          </svg>
                        </a>
                      </td>
                      {/* {sub != true ? (
                        <td>
                          <div class="dropdown">
                            <button
                              class="dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <img
                                src="\assets\more-icon.svg"
                                alt="img"
                                className="img-fluid"
                              />
                            </button>
                            <ul class="dropdown-menu">
                              <li>
                                <a
                                  onClick={() => {
                                    setRoutes(true);
                                    setUserDel(item);
                                    setBlockUnblock(item?.isDeleted);
                                  }}
                                  class="dropdown-item"
                                  href="#"
                                >
                                  <img
                                    src="\assets\viewdetail.svg"
                                    alt="img"
                                    className="img-fluid"
                                  />
                                  View Details
                                </a>
                              </li>
                              <li>
                                <a
                                  onClick={() => {
                                    setShow(true);
                                    setUserDel(item);
                                    setBlockUnblock(item?.isDeleted);
                                  }}
                                  class="dropdown-item"
                                  href="#"
                                >
                                  {item?.isDeleted ? (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="21"
                                      viewBox="0 0 20 21"
                                      fill="none"
                                    >
                                      <path
                                        d="M15.7039 11.7518H16.1206C16.3973 11.7518 16.6614 11.8618 16.8573 12.0568C16.9751 12.1707 17.1329 12.2337 17.2968 12.2324C17.4607 12.2311 17.6175 12.1654 17.7334 12.0496C17.8493 11.9337 17.9151 11.777 17.9166 11.6131C17.9181 11.4493 17.8552 11.2914 17.7414 11.1734C17.3114 10.7434 16.7281 10.5018 16.1206 10.5018H15.7939C15.4855 10.4896 15.1778 10.54 14.8893 10.6497C14.6008 10.7594 14.3374 10.9263 14.115 11.1403C13.8926 11.3543 13.7157 11.6111 13.5949 11.8952C13.4741 12.1792 13.412 12.4848 13.4123 12.7934V14.0434C13.4123 14.2092 13.4781 14.3682 13.5953 14.4854C13.7125 14.6026 13.8715 14.6684 14.0373 14.6684C14.203 14.6684 14.362 14.6026 14.4792 14.4854C14.5964 14.3682 14.6623 14.2092 14.6623 14.0434V12.7934C14.6627 12.5173 14.7726 12.2526 14.9678 12.0574C15.1631 11.8621 15.4278 11.7522 15.7039 11.7518Z"
                                        fill="#28E664"
                                      />
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M18.75 17.7967V14.88C18.75 14.4933 18.5963 14.1223 18.3229 13.8488C18.0494 13.5753 17.6784 13.4217 17.2917 13.4217H13.5417C13.1549 13.4217 12.784 13.5753 12.5105 13.8488C12.237 14.1223 12.0833 14.4933 12.0833 14.88V17.7967C12.0833 18.6025 12.7367 19.255 13.5417 19.255H17.2917C17.6784 19.255 18.0494 19.1014 18.3229 18.8279C18.5963 18.5544 18.75 18.1835 18.75 17.7967ZM15 16.9634H15.8333C15.9991 16.9634 16.1581 16.8975 16.2753 16.7803C16.3925 16.6631 16.4583 16.5041 16.4583 16.3384C16.4583 16.1726 16.3925 16.0136 16.2753 15.8964C16.1581 15.7792 15.9991 15.7134 15.8333 15.7134H15C14.8342 15.7134 14.6753 15.7792 14.5581 15.8964C14.4408 16.0136 14.375 16.1726 14.375 16.3384C14.375 16.5041 14.4408 16.6631 14.5581 16.7803C14.6753 16.8975 14.8342 16.9634 15 16.9634Z"
                                        fill="#28E664"
                                      />
                                      <path
                                        d="M9.79166 10.9031C12.323 10.9031 14.375 8.85109 14.375 6.31978C14.375 3.78848 12.323 1.73645 9.79166 1.73645C7.26036 1.73645 5.20833 3.78848 5.20833 6.31978C5.20833 8.85109 7.26036 10.9031 9.79166 10.9031Z"
                                        fill="#28E664"
                                      />
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M11.5025 18.8298C11.3358 18.5062 11.2492 18.1472 11.25 17.7831V14.8665C11.25 14.1548 12.094 13.4891 12.6032 13.0691V12.7533C12.6032 12.4191 12.6565 12.09 12.759 11.7783C11.9492 11.6531 10.6111 11.6205 9.79168 11.6215C7.02335 11.6215 4.57252 12.314 3.05085 13.3515C1.89002 14.1431 1.25002 15.149 1.25002 16.2048V17.4131C1.25046 17.7887 1.39985 18.1488 1.66543 18.4144C1.93102 18.68 2.29109 18.8294 2.66668 18.8298H11.5025Z"
                                        fill="#28E664"
                                      />
                                    </svg>
                                  ) : (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="21"
                                      viewBox="0 0 20 21"
                                      fill="none"
                                    >
                                      <path
                                        d="M9.99999 10.9167C12.5313 10.9167 14.5833 8.86464 14.5833 6.33333C14.5833 3.80203 12.5313 1.75 9.99999 1.75C7.46868 1.75 5.41666 3.80203 5.41666 6.33333C5.41666 8.86464 7.46868 10.9167 9.99999 10.9167Z"
                                        fill="#FE0000"
                                      />
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M11.7108 18.8434C11.5441 18.5197 11.4575 18.1608 11.4583 17.7967V14.88C11.4583 14.1684 11.7825 13.5325 12.2917 13.1125V12.7967C12.2917 12.4625 12.345 12.1334 12.4475 11.8217C11.6377 11.6965 10.8194 11.6341 10 11.635C7.23168 11.635 4.78084 12.3275 3.25918 13.365C2.09834 14.1567 1.45834 15.1625 1.45834 16.2184V17.4267C1.45878 17.8023 1.60818 18.1624 1.87376 18.4279C2.13934 18.6935 2.49942 18.8429 2.87501 18.8434H11.7108Z"
                                        fill="#FE0000"
                                      />
                                      <path
                                        d="M15.8333 11.755H15.4167C15.1407 11.7559 14.8762 11.8659 14.6811 12.0611C14.4859 12.2562 14.3759 12.5207 14.375 12.7967V14.0467C14.375 14.2124 14.3092 14.3714 14.1919 14.4886C14.0747 14.6058 13.9158 14.6717 13.75 14.6717C13.5842 14.6717 13.4253 14.6058 13.3081 14.4886C13.1908 14.3714 13.125 14.2124 13.125 14.0467V12.7967C13.1254 12.189 13.367 11.6064 13.7967 11.1767C14.2264 10.747 14.809 10.5054 15.4167 10.505H15.7433C16.0518 10.4929 16.3595 10.5432 16.648 10.6529C16.9365 10.7626 17.1999 10.9295 17.4223 11.1435C17.6447 11.3576 17.8216 11.6143 17.9424 11.8984C18.0631 12.1825 18.1252 12.488 18.125 12.7967V14.0467C18.125 14.2124 18.0592 14.3714 17.9419 14.4886C17.8247 14.6058 17.6658 14.6717 17.5 14.6717C17.3342 14.6717 17.1753 14.6058 17.0581 14.4886C16.9408 14.3714 16.875 14.2124 16.875 14.0467V12.7967C16.8746 12.5205 16.7647 12.2558 16.5694 12.0606C16.3742 11.8653 16.1095 11.7554 15.8333 11.755Z"
                                        fill="#FE0000"
                                      />
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M18.9583 17.7967V14.88C18.9583 14.4933 18.8047 14.1223 18.5312 13.8488C18.2577 13.5753 17.8868 13.4217 17.5 13.4217H13.75C13.3632 13.4217 12.9923 13.5753 12.7188 13.8488C12.4453 14.1223 12.2917 14.4933 12.2917 14.88V17.7967C12.2917 18.6025 12.945 19.255 13.75 19.255H17.5C17.8868 19.255 18.2577 19.1014 18.5312 18.8279C18.8047 18.5544 18.9583 18.1835 18.9583 17.7967ZM15 15.9217V16.755C15 16.9208 15.0658 17.0798 15.183 17.197C15.3003 17.3142 15.4592 17.38 15.625 17.38C15.7908 17.38 15.9497 17.3142 16.0669 17.197C16.1841 17.0798 16.25 16.9208 16.25 16.755V15.9217C16.25 15.7559 16.1841 15.597 16.0669 15.4798C15.9497 15.3625 15.7908 15.2967 15.625 15.2967C15.4592 15.2967 15.3003 15.3625 15.183 15.4798C15.0658 15.597 15 15.7559 15 15.9217Z"
                                        fill="#FE0000"
                                      />
                                    </svg>
                                  )}

                                  {item?.isDeleted ? "Unblock" : "Block"}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      ) : null} */}
                    </tr>
                  );
                })
              ) : leadersLoader ? (
                <tr>
                  <td colSpan="12" className="text-center">
                    <div className="text-center">
                      <div class="d-flex align-items-center justify-content-center">
                        <div class="spinner-border text-info" role="status">
                          <span class="sr-only"></span>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    <div className="text-center">
                      <h6
                        className=""
                        style={{
                          color: "#fff",
                          textAlign: "center",
                          marginTop: 60,
                        }}
                      >
                        No data found!
                      </h6>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {pagination ? (
          <div className="footer-content mblviewdisplaynone mt-2">
            <div className="left-f">
              {/* <h6>SHOWING 1-10 OF 145</h6> */}
              {/* <h6>SHOWING 1-10 OF 145</h6> */}
            </div>
            <div className="right-f">
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <nav aria-label="Page navigation example">
                    <ul class="text-center">
                      <ReactPaginate
                        previousLabel={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M12.6665 8L3.33317 8"
                              stroke="#042B33"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M8 3.33329L3.33333 7.99996L8 12.6666"
                              stroke="#042B33"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        }
                        nextLabel={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M3.3335 8L12.6668 8"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M8 3.33329L12.6667 7.99996L8 12.6666"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        }
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakLabel="..."
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageChange}
                        containerClassName="pagination"
                        activeClassName="active"
                        forcePage={page}
                      ></ReactPaginate>
                    </ul>
                  </nav>
                </ul>
              </nav>
            </div>
          </div>
        ) : null}
        <div className="mobiledesignss  d-none">
          {agents?.length > 0 ? (
            agents?.map((item, index) => {
              return (
                <div className="new-accordionmobile dsuygfdsyufgsdyuf d-none">
                  <div className="upper-body">
                    <div className="inner-text">
                      <h6>Date and time</h6>
                      <p> {convertDateFormat(item?.createdAt)?.slice(0, 10)}</p>
                    </div>
                    <div className="inner-text">
                      <h6>Leader</h6>
                      <p>{item?.name}</p>
                    </div>
                    <div className="inner-text">
                      <h6>Leader's Email</h6>
                      <p>{item?.email}</p>
                    </div>
                    <div className="inner-text">
                      <h6>Role</h6>
                      <p>{convertToTitleCase(item?.role)}</p>
                    </div>

                    <div className="inner-text">
                      <h6>Wallet Address</h6>
                      {copy ? (
                        <p className="adadasdasdasdasdasdsad">
                          {item?.walletAddress?.slice(0, 8)}...
                          {item?.walletAddress?.slice(
                            item?.walletAddress?.length - 5,
                            item?.walletAddress?.length,
                          )}
                          <svg
                            style={{ cursor: "pointer" }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            className=""
                          >
                            <path
                              d="M13 10.5V13.5C13 16 12 17 9.5 17H6.5C4 17 3 16 3 13.5V10.5C3 8 4 7 6.5 7H9.5C12 7 13 8 13 10.5Z"
                              stroke="#77868B"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M17 6.5V9.5C17 12 16 13 13.5 13H12.7143V10.7857C12.7143 8.28571 11.7143 7.28571 9.21429 7.28571H7V6.5C7 4 8 3 10.5 3H13.5C16 3 17 4 17 6.5Z"
                              stroke="#77868B"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </p>
                      ) : (
                        <>
                          {item?.walletAddress && (
                            <CopyToClipboard
                              text={item?.walletAddress}
                              onCopy={(e) => textCopiedFun(index)}
                            >
                              <p className="adadasdasdasdasdasdsad">
                                {item?.walletAddress?.slice(0, 8)}...
                                {item?.walletAddress?.slice(
                                  item?.walletAddress?.length - 5,
                                  item?.walletAddress?.length,
                                )}
                                <svg
                                  style={{ cursor: "pointer" }}
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  className=""
                                >
                                  <path
                                    d="M13 10.5V13.5C13 16 12 17 9.5 17H6.5C4 17 3 16 3 13.5V10.5C3 8 4 7 6.5 7H9.5C12 7 13 8 13 10.5Z"
                                    stroke="#77868B"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M17 6.5V9.5C17 12 16 13 13.5 13H12.7143V10.7857C12.7143 8.28571 11.7143 7.28571 9.21429 7.28571H7V6.5C7 4 8 3 10.5 3H13.5C16 3 17 4 17 6.5Z"
                                    stroke="#77868B"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </p>
                            </CopyToClipboard>
                          )}
                        </>
                      )}
                    </div>
                    <div className="inner-text">
                      <h6>Plan</h6>
                      <p>{item?.UserPremiumPlan ? "Premium" : "Basic"}</p>
                    </div>
                    {/* <div className="inner-text">
                    <h6>Wallet Address</h6>
                    <p className="textright">
                      {item?.walletAddress?.slice(0, 11)}...
                      {item?.walletAddress?.slice(
                        item?.walletAddress?.length - 3,
                        item?.walletAddress?.length
                      )}
                      <img
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          navigator.clipboard.writeText(item?.walletAddress);
                        }}
                        src="\assets\copy.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </p>
                  </div> */}
                  </div>
                  <div className="bottom-body">
                    <Accordion>
                      <Accordion.Item eventKey={index}>
                        <Accordion.Header>
                          More Info{" "}
                          <img
                            src="\assets\arrow-down.svg"
                            alt="img"
                            className="img-fluid"
                          />
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="inner-textt">
                            <p>Miners Sold</p>

                            <h6 className="textright">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                {parseFloat(
                                  item?.totalMiniMiners +
                                    item?.totalMegaMiners +
                                    item?.totalStandardMiners,
                                )?.toLocaleString()}
                                <div class="dropdown dropdownnodesminers">
                                  <button
                                    class="dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="19"
                                      viewBox="0 0 18 19"
                                      fill="none"
                                    >
                                      <path
                                        d="M9 17.249C13.1421 17.249 16.5 13.8912 16.5 9.74902C16.5 5.60689 13.1421 2.24902 9 2.24902C4.85786 2.24902 1.5 5.60689 1.5 9.74902C1.5 13.8912 4.85786 17.249 9 17.249Z"
                                        stroke="#77868B"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M9 12.749V9.74902"
                                        stroke="#77868B"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M9 6.74902H9.00833"
                                        stroke="#77868B"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </button>
                                  <ul
                                    class="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton1"
                                  >
                                    <div className="twice">
                                      <p>Mini</p>
                                      <h6>{item?.totalMiniMiners}</h6>
                                    </div>
                                    <div className="twice">
                                      <p>Standard</p>
                                      <h6>{item?.totalStandardMiners}</h6>
                                    </div>
                                    <div className="twice">
                                      <p>Mega</p>
                                      <h6>{item?.totalMegaMiners}</h6>
                                    </div>
                                  </ul>
                                </div>
                              </div>
                            </h6>
                          </div>
                          <div className="inner-textt">
                            <p>Leader Earnings</p>

                            {usdPrice ? (
                              <div className="twice-text">
                                <>
                                  <h6>
                                    $
                                    {formatTokenValue(
                                      item?.totalAmountEarned,
                                      2,
                                    )}
                                  </h6>
                                  <p>
                                    {
                                      <p>
                                        {[
                                          item?.myEarningsEth > 0
                                            ? `${item?.myEarningsEth?.toFixed(
                                                5,
                                              )} ETH`
                                            : null,
                                          item?.myEarningsUsdt > 0
                                            ? `${item?.myEarningsUsdt?.toFixed(
                                                2,
                                              )} USDT`
                                            : null,
                                          item?.myEarningsUsdc > 0
                                            ? `${item?.myEarningsUsdc?.toFixed(
                                                2,
                                              )} USDC`
                                            : null,
                                          item?.myEarningsDopToken > 0
                                            ? `${item?.myEarningsDopToken?.toFixed(
                                                2,
                                              )} DOP`
                                            : null,
                                          item?.myEarningsWbtc > 0
                                            ? `${item?.myEarningsWbtc?.toFixed(
                                                6,
                                              )} WBTC`
                                            : null,
                                          item?.myEarningsPepe > 0
                                            ? `${item?.myEarningsPepe?.toFixed(
                                                2,
                                              )} PEPE`
                                            : null,
                                          item?.myEarningsLink > 0
                                            ? `${item?.myEarningsLink?.toFixed(
                                                2,
                                              )} LINK`
                                            : null,
                                          item?.myEarningsUni > 0
                                            ? `${item?.myEarningsUni?.toFixed(
                                                2,
                                              )} UNI`
                                            : null,
                                          item?.myEarningsTomi > 0
                                            ? `${item?.myEarningsTomi?.toFixed(
                                                2,
                                              )} TOMI`
                                            : null,
                                          item?.myEarningsGems > 0
                                            ? `${item?.myEarningsGems?.toFixed(
                                                1,
                                              )} GEMS`
                                            : null,
                                        ]
                                          .filter(Boolean) // Removes null values
                                          .join(" + ")}
                                      </p>
                                    }
                                  </p>
                                </>
                              </div>
                            ) : (
                              <div className="twice-text">
                                <>
                                  <h6>$0</h6>
                                </>
                              </div>
                            )}
                          </div>
                          {/* totalPurchaseUsdt */}
                          <div className="inner-textt">
                            <p>Total Purchases</p>
                            {usdPrice ? (
                              <div className="twice-text">
                                <>
                                  <h6>
                                    $
                                    {(
                                      item?.totalEthDirect * usdPrice +
                                      item?.totalUsdtDirect +
                                      (item?.totalDopTokenDirect || 0) *
                                        dopPrice +
                                      item?.totalWbtcDirect * btcPrice +
                                      item?.totalUsdcDirect +
                                      item?.totalPepeDirect * pepePrice +
                                      item?.totalLinkDirect * linkPrice +
                                      item?.totalUniDirect * uniPrice +
                                      item?.totalTomiDirect * tomiPrice +
                                      item?.totalGemsDirect * gemsPrice
                                    )?.toFixed(2)}
                                  </h6>
                                  <p>
                                    {[
                                      item?.totalEthDirect > 0
                                        ? `${item?.totalEthDirect?.toFixed(
                                            5,
                                          )} ETH`
                                        : null,
                                      item?.totalUsdtDirect > 0
                                        ? `${item?.totalUsdtDirect?.toFixed(
                                            2,
                                          )} USDT`
                                        : null,
                                      item?.totalUsdcDirect > 0
                                        ? `${item?.totalUsdcDirect?.toFixed(
                                            2,
                                          )} USDC`
                                        : null,
                                      item?.totalDopTokenDirect > 0
                                        ? `${item?.totalDopTokenDirect?.toFixed(
                                            2,
                                          )} DOP`
                                        : null,
                                      item?.totalWbtcDirect > 0
                                        ? `${item?.totalWbtcDirect?.toFixed(
                                            6,
                                          )} WBTC`
                                        : null,
                                      item?.totalPepeDirect > 0
                                        ? `${item?.totalPepeDirect?.toFixed(
                                            2,
                                          )} PEPE`
                                        : null,
                                      item?.totalLinkDirect > 0
                                        ? `${item?.totalLinkDirect?.toFixed(
                                            2,
                                          )} LINK`
                                        : null,
                                      item?.totalUniDirect > 0
                                        ? `${item?.totalUniDirect?.toFixed(
                                            2,
                                          )} UNI`
                                        : null,
                                      item?.totalTomiDirect > 0
                                        ? `${item?.totalTomiDirect?.toFixed(
                                            2,
                                          )} TOMI`
                                        : null,
                                      item?.totalGemsDirect > 0
                                        ? `${item?.totalGemsDirect?.toFixed(
                                            1,
                                          )} GEMS`
                                        : null,
                                    ]
                                      .filter(Boolean) // Removes null values
                                      .join(" + ")}
                                  </p>
                                </>
                              </div>
                            ) : (
                              <div className="twice-text">
                                <>
                                  <h6>$0</h6>
                                </>
                              </div>
                            )}
                          </div>
                          {sub != true ? (
                            <div className="inner-textt">
                              <button
                                onClick={() => {
                                  setRoutes(true);
                                  setUserDel(item);
                                  setBlockUnblock(item?.isDeleted);
                                }}
                                className="view-btn"
                              >
                                View Details
                              </button>
                            </div>
                          ) : null}
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </div>
                </div>
                // <Accordion.Item key={index} eventKey={index}>
                //   <Accordion.Header>
                //     <div className="accheadermain">
                //       <p className="acctext">
                //         {convertDateFormat(item?.createdAt)?.slice(0, 10)}
                //       </p>
                //       <p className="acctext">{item?.name}</p>
                //       <p className="acctext">
                //         {convertToTitleCase(item?.role)}
                //       </p>
                //     </div>
                //   </Accordion.Header>
                //   <Accordion.Body>
                //     <div className="acctexts">
                //       <h6 className="textleft">Wallet Address</h6>
                //       <p className="textright">
                //         {item?.walletAddress?.slice(0, 11)}...
                //         {item?.walletAddress?.slice(
                //           item?.walletAddress?.length - 3,
                //           item?.walletAddress?.length
                //         )}
                //         <img
                //           style={{ cursor: "pointer" }}
                //           onClick={() => {
                //             navigator.clipboard.writeText(item?.walletAddress);
                //           }}
                //           src="\assets\copy.svg"
                //           alt="img"
                //           className="img-fluid"
                //         />
                //       </p>
                //     </div>
                //     <div className="acctexts">
                //       <h6 className="textleft">DOP Purchased</h6>
                //       <p className="textright">{item?.totalDop} DOP</p>
                //     </div>
                //     <div className="acctexts">
                //       <h6 className="textleft">Leader Earning</h6>
                //       <div className="twice-text">
                //         <h6>
                //           $
                //           {(
                //             item?.myEarningsEth * usdPrice +
                //             item?.myEarningsUsdt
                //           )?.toFixed(4)}
                //         </h6>
                //         <p>
                //           ({item?.myEarningsEth} ETH + {item?.myEarningsUsdt}{" "}
                //           USDT)
                //         </p>
                //       </div>
                //     </div>
                //     <div className="acctexts">
                //       <h6 className="textleft">Total Purchases</h6>
                //       <div className="twice-text">
                //         <h6>
                //           {(
                //             item?.totalEth * usdPrice +
                //             item?.totalUsdt
                //           )?.toFixed(4)}{" "}
                //         </h6>
                //         <p>
                //           ({item?.totalEth} ETH + {item?.totalUsdt} USDT){" "}
                //         </p>
                //       </div>
                //     </div>
                //     <div className="acctexts">
                //       <button
                //          onClick={() => {
                //           setRoutes(true);
                //           setUserDel(item);
                //         }}
                //         className="view-btn"
                //       >
                //         View Details
                //       </button>
                //     </div>
                //   </Accordion.Body>
                // </Accordion.Item>
              );
            })
          ) : leadersLoader ? (
            <tr>
              <td colSpan="12" className="text-center">
                <div className="text-center">
                  <div class="d-flex align-items-center justify-content-center">
                    <div class="spinner-border text-info" role="status">
                      <span class="sr-only"></span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          ) : (
            <tr>
              <td colSpan="10" className="text-center">
                <div className="text-center">
                  <h6
                    className=""
                    style={{
                      color: "#fff",
                      textAlign: "center",
                      marginTop: 60,
                    }}
                  >
                    No data found!
                  </h6>
                </div>
              </td>
            </tr>
          )}
          {pagination ? (
            <div className="footer-content mt-2">
              <div className="left-f">
                {/* <h6>SHOWING 1-10 OF 145</h6> */}
                {/* <h6>SHOWING 1-10 OF 145</h6> */}
              </div>
              <div className="right-f">
                <nav aria-label="Page navigation example">
                  <ul class="pagination">
                    <nav aria-label="Page navigation example">
                      <ul class="text-center">
                        <ReactPaginate
                          previousLabel={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M12.6667 8L3.33335 8"
                                stroke="#042B33"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M8 3.33342L3.33333 8.00008L8 12.6667"
                                stroke="#042B33"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          }
                          nextLabel={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M3.33331 8L12.6666 8"
                                stroke="white"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M8 3.33342L12.6667 8.00008L8 12.6667"
                                stroke="white"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          }
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          previousClassName="page-item"
                          previousLinkClassName="page-link"
                          nextClassName="page-item"
                          nextLinkClassName="page-link"
                          breakLabel="..."
                          breakClassName="page-item"
                          breakLinkClassName="page-link"
                          pageCount={pageCount}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          onPageChange={handlePageChange}
                          containerClassName="pagination"
                          activeClassName="active"
                          forcePage={page}
                        ></ReactPaginate>
                      </ul>
                    </nav>
                  </ul>
                </nav>
              </div>
            </div>
          ) : null}
        </div>
      </section>

      <Modal
        className="global-modal-scss tokenslist-modal"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Total Purchases</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-tokendata">
            <div className="upper-twice-card">
              <div className="single-card">
                <p>Leader Name</p>
                <h6>{modalDetail?.name}</h6>
              </div>
              <div className="single-card">
                <p>Total Purchases</p>
                <h6>~${formatTokenValue(modalDetail?.totalAmountInUsd)} </h6>
              </div>
            </div>
            <div className="bottom-twice">
              <div className="upper-head">
                <p>Token</p>
                <p>Amount</p>
              </div>
              {tokenData
                .map(({ key, name, img, decimals }) => ({
                  value: formatTokenValue(modalDetail?.[key], decimals),
                  name,
                  img,
                }))
                .filter(({ value }) => value !== null) // Remove zero values
                .map(({ name, value, img }) => (
                  <div className="bottom-tokens" key={name}>
                    <div className="left-token">
                      <img src={img} alt={name} className="img-fluid" />
                      <h6>{name}</h6>
                    </div>
                    <div className="right-token">
                      <p>
                        {value} {name}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>

          <div className="twice-btn">
            <button
              className="btn-add w-100"
              style={{ flex: "0 0 100%" }}
              onClick={() => {
                handleClose1();
              }}
            >
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="global-modal-scss tokenslist-modal"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Leader Earnings</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-tokendata">
            <div className="upper-twice-card">
              <div className="single-card">
                <p>Leader Name</p>
                <h6>{modalDetail?.name}</h6>
              </div>
              <div className="single-card">
                <p>Total Earnings</p>
                <h6>~${formatTokenValue(modalDetail?.totalAmountEarned)} </h6>
              </div>
            </div>
            <div className="bottom-twice">
              <div className="upper-head">
                <p>Token</p>
                <p>Amount</p>
              </div>
              {tokenDataEarnings
                .map(({ key, name, img, decimals }) => ({
                  value: formatTokenValue(modalDetail?.[key], decimals),
                  name,
                  img,
                }))
                .filter(({ value }) => value !== null) // Remove zero values
                .map(({ name, value, img }) => (
                  <div className="bottom-tokens" key={name}>
                    <div className="left-token">
                      <img src={img} alt={name} className="img-fluid" />
                      <h6>{name}</h6>
                    </div>
                    <div className="right-token">
                      <p>
                        {value} {name}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>

          <div className="twice-btn">
            <button
              className="btn-add w-100"
              style={{ flex: "0 0 100%" }}
              onClick={() => {
                handleClose2();
              }}
            >
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DataTable;
